import { Box, Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppBody from "../AppBody";
import AppHeader from "../AppHeader";
import {
  IFonctionnalite,
  setFilterFonctionnalites,
  setFonctionnalites
} from "../components/GestionFonctionnalite/Fonctionnalite/fonctionnaliteSlice";
import {
  IGroupeFonctionnalite,
  setGroupeFonctionnalites
} from "../components/GestionFonctionnalite/GroupeFonctionnalite/groupeFonctionnaliteSlice";
import {
  IModule,
  setModules
} from "../components/GestionFonctionnalite/Module/moduleSlice";
import {
  ISousModule,
  setSousModules
} from "../components/GestionFonctionnalite/SousModule/sousModuleSlice";
import { setFilteredNveauAcces, setNveauAcces } from "../components/GestionNiveauAccès/niveauAccesSlice";
import { IReduxState } from "../store";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../util/apiClient";
import GestionUtilisateur from "../GestionUtilisateur";
import { setTypeUtilisateur } from "../store/userSlice";
import { Tirage } from "../Tirage";
import { setAnneesScolaires, setEnseignants, setEtabsAppelNote, setFetchingEnseignants } from "../store/focusEcoleSlice";
import _ from "lodash";
import { setFilteredPartenaires, setPartenaires } from "../store/partenaireSlice";
import { Dashbord } from "../Dashbord";



function Accueil() {
  //redux
  const dispatch = useDispatch();
  const { fonctionnalites } = useSelector(
    (state: IReduxState) => state.fonctionnalite
  );
  const { goToParameter, goToTirage, goToDashbord } = useSelector((state: IReduxState) => state.application);
  const { enseignants } = useSelector((state: IReduxState) => state.focusEcole);

  //hooks
  const theme = useTheme();
  const modeEcran = useMediaQuery(theme.breakpoints.down("lg"));

  //fetcher les donnees puis mettre dans le store




  //les modules
  const getModulesData = async () => {
    try {
      const res: any = await apiClient.get(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/listemodule"
      );
      if (res.status === 1) {
        const x = res.data.map((m: IModule) => {
          return { ...m, id: m.idModule, libelle: m.libelleModule };
        });
        dispatch(setModules(x));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: Accueil.tsx ~ line 46 ~ getDatas ~ error", error);
    }
  };

  //les sousmodules
  const getSousModulesData = async () => {
    try {
      const res: any = await apiClient.get(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/listesousmodule"
      );
      if (res.status === 1) {
        const x = res.data.map((sm: ISousModule) => {
          return { ...sm, id: sm.idSousModule, libelle: sm.libelleSousModule };
        });
        dispatch(setSousModules(x));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: Accueil.tsx ~ line 46 ~ getDatas ~ error", error);
    }
  };

  //les groupe fonctionnalites
  const getGroupeFonctionnalitesData = async () => {
    try {
      const res: any = await apiClient.get(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/listegroupefonctionnalite"
      );
      if (res.status === 1) {
        const x = res.data.map((gf: IGroupeFonctionnalite) => {
          return {
            ...gf,
            id: gf.idGroupeFonctionnalite,
            libelle: gf.libelleGroupeFonctionnalite,
          };
        });
        dispatch(setGroupeFonctionnalites(x));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: Accueil.tsx ~ line 46 ~ getDatas ~ error", error);
    }
  };

  //les groupe fonctionnalites
  const getFonctionnalitesData = async () => {
    try {
      const res: any = await apiClient.get(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/listefonctionnalite"
      );
      if (res.status === 1) {
        const x = res.data.map((f: IFonctionnalite) => {
          return {
            ...f,
            id: f.idFonctionnalite,
            libelle: f.libelleFonctionnalite,
          };
        });
        dispatch(setFonctionnalites(x));
        dispatch(setFilterFonctionnalites(x));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: Accueil.tsx ~ line 46 ~ getDatas ~ error", error);
    }
  };


  //Obtenir la liste des niveaux d'acces
  const getNveauAccesData = async () => {
    try {
      // dispatch(setNveauAcces(fakeNA))
      const res: any = await apiClient.get(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/niveauxaccesgloballist"
      );
      if (res.status === 1) {
        dispatch(setNveauAcces(res.data));
        dispatch(setFilteredNveauAcces(res.data));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: Accueil.tsx ~ line 46 ~ getDatas ~ error", error);
    }
  };

  //Obtenir la liste des types utilisateurs
  const getListeTypeUtilisateur = async () => {
    try {
      const res: any = await apiClient.get(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/listeTypeUtilisateur"
      );
      if (res.status === 1) {
        dispatch(setTypeUtilisateur(res.data));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: Accueil.tsx:173 ~ getListeTypeUtilisateur ~ error:", error)
    }
  };


  const getEnseignants = async () => {
    try {
      dispatch(setFetchingEnseignants(true))
      const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, "/tablesystem/getenseignants");
      if (res.status === 1) {
        const { ennvoiNote, envoiAppel } = res.data.data

        //Obtenir les enseignants qui ont fait au moins un appel et envoyé les notes en ligne
        const commonArray = _.intersectionBy(envoiAppel, ennvoiNote, 'idPersonnel')

        //Trier la liste des enseignants par ordre alphabetique puis exclure 000002 et 000000
        const enseignDistinctTrie = _.orderBy(
          commonArray.filter((etab: any) => !['000002', '000000','202235','000005'].includes(etab.codeEtab)),
          ['nomPersonnel', 'prenomPersonnel'],
          ['asc', 'asc']
        );

        //Obtenir distinctement les annnées scolaires présentes dans la liste
        const anScolDistinct = _.uniqBy(commonArray, 'anneeScolaire');

        //Obtenir distinctement les établissements présents dans la liste puis exclure 000002 et 000000
        const etabsDistinct = _.uniqBy(
          commonArray.filter((etab: any) => !['000002', '000000'].includes(etab.codeEtab)), 'codeEtab');



        // dispatch(setEnseignantEtabs(enseignDistinctTrie))
        // dispatch(setFilteredEnseignants(enseignDistinctTrie))
        //

        dispatch(setEnseignants(enseignDistinctTrie))
        dispatch(setAnneesScolaires(anScolDistinct))
        dispatch(setEtabsAppelNote(etabsDistinct))
      } else {
        console.log("getEnseignants status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:63 ~ getEnseignants ~ error:", error)
    } finally {
      dispatch(setFetchingEnseignants(false))
    }
  };

  const getEnseignantsEnvoiePlusNotesAppels = async () => {
    try {
      dispatch(setFetchingEnseignants(true))
      const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, "/tablesystem/getenseignantsenvoieplusnotesappels");
      console.log("🚀 ~ getEnseignantsEnvoiePlusNotesAppels ~ res:", res)
      if (res.status === 1) {
        console.log("🚀 ~ getEnseignantsEnvoiePlusNotesAppels ~ res.data:", res.data)
        dispatch(setEnseignants(res.data))
      } else {
        console.log("getEnseignants status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ getEnseignantsEnvoiePlusNotesAppels ~ error:", error)
    } finally {
      dispatch(setFetchingEnseignants(false))
    }
  };


  const getListpartenaires = async () => {
    try {
      const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, "/tablesystem/listpartenaires");
      if (res.status === 1) {
        dispatch(setPartenaires(res.data))
        dispatch(setFilteredPartenaires(res.data))
      } else {
        console.log("getListpartenaires status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ getListpartenaires ~ error:", error)
    };
  };


  useEffect(() => {
    getModulesData();
    getSousModulesData();
    getGroupeFonctionnalitesData();
    getFonctionnalitesData();
    getNveauAccesData();
    getListeTypeUtilisateur();
    getEnseignantsEnvoiePlusNotesAppels();
    getListpartenaires();
  }, []);


  const renderComponent = () => {
    if (goToParameter) {
      return (<GestionUtilisateur />)
    } else if (goToTirage) {
      return (<Tirage />)
    } else if (goToDashbord) {
      return (<Dashbord />)
    } else {
      return (<AppBody />)
    }
  }


  return (
    <div style={{ overflow: "hidden" }} className="corp-couleur-simple">
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12}>
            <AppHeader />
          </Grid>
        </Grid>

        <Grid
          container
          spacing={0}
          style={{ marginTop: 100 }}
        >
          <Grid item xs={12} md={12}>
            {renderComponent()}
            {/* {goToParameter
              ? <GestionUtilisateur />
              : <AppBody />
            } */}

          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default Accueil;
